import defineComponent from 'flight';

function InputNumberUI() {
    this.defaultAttrs({
        inputNumberSelector: 'input[type="number"]',
        maxLengthAttr: 'data-maxlength'
    });

    this._verifyInput = function(evt, payload) {
        let $el = $(payload.el);

        if ($el.attr(this.attr.maxLengthAttr)) {
            let maxLength = parseInt($el.attr(this.attr.maxLengthAttr), 10);
            if (payload.el.value.length > maxLength) {
                let res = payload.el.value.substring(0, maxLength);
                $el.val(res);
            }
        }
    };

    this.after('initialize', function() {
        this.on('keyup', {
            inputNumberSelector: this._verifyInput
        });
    });
}

export default defineComponent.component(InputNumberUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/input-number-ui.js